// Initialize Firebase
const productionConfiguration = {
    apiKey: "AIzaSyC4eV1jyRvcRj4z43bfNVJEAUfqRr9vjd4",
    authDomain: "box-live-1d382.firebaseapp.com",
    databaseURL: "https://box-live-1d382.firebaseio.com",
    projectId: "box-live-1d382",
    storageBucket: "box-live-1d382.appspot.com",
    messagingSenderId: "814385958822",
    appId: "1:814385958822:web:83df968354613f5004c967",
    measurementId: "G-YYN1DXW46S",
};

// const stagingConfiguration = {
//     apiKey: "AIzaSyDn3IoE90Z3G-ByWsWP53Lx4bOYAUtxJkk",
//     authDomain: "hyc-test-777bb.firebaseapp.com",
//     databaseURL: "https://hyc-test-777bb.firebaseio.com",
//     projectId: "hyc-test-777bb",
//     storageBucket: "hyc-test-777bb.appspot.com",
//     messagingSenderId: "312873777343",
//     appId: "1:312873777343:web:020d97ec83b799b3c42e0a",
//     measurementId: "G-6TTVHSB25H",
// };

let environment = "development";
let configuration = productionConfiguration;

const isTestEnv = window.location.host.includes("hyc-test-777bb");
if (process.env.NODE_ENV === "production" && !isTestEnv) {
    environment = process.env.NODE_ENV;
    configuration = productionConfiguration;
}

console.log(`Loading firebase ${environment} configuration.`);

export default configuration;
